import React from "react";
import './MarketElement.css';
import ButtonStandart from "../../../Elements/Buttons/ButtonStandart/ButtonStandart";
import minusinround from "../../../../img/Market/minusinround.svg";
import plusinround from "../../../../img/Market/plusinround.svg";
import {BUY_UNITEN} from "../../../../queries";

import {Mutation} from "react-apollo";

class MarketElement extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            email:this.props.email,
            Quantity : this.props.Quantity,
            EconomicUnites : this.props.EconomicUnites,
            PropertyUnites  : this.props.PropertyUnites,
            IndexUnites  : this.props.IndexUnites,
            IndustryUnites : this.props.IndustryUnites
        };
        this.ChangeQuantity = this.ChangeQuantity.bind(this);
        this.UserbuyUniten = this.UserbuyUniten.bind(this);
    }

    ChangeQuantity = (event, number) => {
        if (this.state.Quantity + number > 0) {this.setState({Quantity: this.state.Quantity + number});}
    };

    UserbuyUniten = (event, buyUniten) => {
        event.preventDefault();
        buyUniten().then(({data}) => {
            console.log('buyUniten работает',data.buyUniten);
            //this.setState({Balance : data.giveMoney.Balance})
        })
    };

    render(){

        return (
    <div className="MarketElement">
        <div className="MarketElementImage"><img src={this.props.Image} width="48px" height="48px"/></div>
        <div className="MarketElementTitle">{this.props.Title}</div>
        <div className="MarketElementText">{this.props.Text} <br/> {this.props.Text2 ? this.props.Text2 : ""}</div>
        <div className="MarketElementQuantity">{this.props.Money + (this.state.Quantity-1)*this.props.MoneyStep}<img src={this.props.ImageMoney} width="20px" height="20px"/></div>
        <div className="MarketElementMoney">
            <div className="MarketElementMoneyPlus" onClick={event => this.ChangeQuantity(event,-1)}> <img src={minusinround} width="20px" height="20px"/> </div>
            <div className="MarketElementMoneyNumber">{this.state.Quantity}</div>
            <div className="MarketElementMoneyMinus" onClick={event => this.ChangeQuantity(event,1)}>  <img src={plusinround}  width="20px" height="20px"/></div>
        </div>
        <Mutation mutation={BUY_UNITEN} variables={{ email:this.state.email, WhatWePay: this.props.WhatWePay, EconomicUnites : this.state.EconomicUnites*(this.props.Money + (this.state.Quantity-1)*this.props.MoneyStep),
            PropertyUnites  : this.state.PropertyUnites*(this.props.Money + (this.state.Quantity-1)*this.props.MoneyStep),
            IndexUnites  : this.state.IndexUnites*(this.props.Money + (this.state.Quantity-1)*this.props.MoneyStep),
            IndustryUnites : this.state.IndustryUnites*(this.props.Money + (this.state.Quantity-1)*this.props.MoneyStep)}}>
            {(buyUniten,{data, loading, error}) => {
                return(
                    <div onClick={event => this.UserbuyUniten(event, buyUniten)} >
                        <ButtonStandart ssilka='#' classname={this.props.ButtonActive ? 'ButtonStandart' : 'ButtonStandartNotActive'} label={this.props.ButtonLabel} ButtonActive={this.props.ButtonActive}/>
                    </div>
                )
            }}
        </Mutation>
    </div>
)}}

export default MarketElement

